import { extend } from 'vee-validate';
import { email, required, numeric } from 'vee-validate/dist/rules';

// No message specified.
extend('required', required);
extend('email', email);
extend('numeric', numeric);